import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Subscription } from 'rxjs';

import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';
import { VtmnPlayButtonShapeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-shape.enum';
import { KeyboardEnum } from '~/component/enums/keyboard.enum';
import { MatchMediaService } from '~/core/services/match-media/match-media.service';
import { CtaButtonTypeEnum } from '../call-to-action/enums/button-type.enum';
import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { VtmnPlayButtonSizeEnum } from '../buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { VtmnPlayIconButtonVariantEnum } from '../buttons/vtmn-play-icon-button/enum/vtmn-play-icon-button-variant.enum';
@Component({
  selector: 'app-chips',
  templateUrl: './chips.component.html',
  styleUrls: ['./chips.component.scss'],
})
export class ChipsComponent implements OnInit, OnDestroy {
  @Input() public buttonText: string;
  @Input() public dialogTitle?: string;
  @Input() public hasSelectedState? = false;

  @Output() public clear = new EventEmitter();

  @ViewChild('dialog') public dialog: ElementRef;

  private readonly subscriptions = new Subscription();

  public readonly ctaButtonType = CtaButtonTypeEnum;
  public readonly vtmnPlayButtonShape = VtmnPlayButtonShapeEnum;
  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
  public readonly vtmnPlayIconButtonVariant = VtmnPlayIconButtonVariantEnum;
  public readonly icon = VtmnPlayIconTypeEnum;

  public isDialogOpen = false;
  public isMobileDevice: boolean;

  constructor(
    private readonly chipsComponent: ElementRef,
    public readonly matchMediaService: MatchMediaService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.dialogTitle = this.dialogTitle || this.buttonText;

    this.subscriptions.add(
      this.matchMediaService.isMobileDevice().subscribe((isMobileDevice) => {
        this.isMobileDevice = isMobileDevice;
      })
    );
  }

  public get backIcon(): VtmnPlayIconTypeEnum {
    return this.isMobileDevice
      ? VtmnPlayIconTypeEnum.ArrowLeft
      : VtmnPlayIconTypeEnum.Close;
  }

  @HostListener('document:click', ['$event.target'])
  private clickout(target): void {
    if (
      !this.chipsComponent.nativeElement.contains(target) &&
      this.isDialogOpen
    ) {
      this.isDialogOpen = false;
    }
  }

  @HostListener('document:keydown', ['$event'])
  private handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === KeyboardEnum.Escape) {
      this.isDialogOpen = false;
    }
  }

  public focusDialogTitle(): void {
    this.dialog?.nativeElement
      .querySelector('.chips__dialog__header__button')
      .focus();
  }

  public focusLastFocusable(): void {
    this.dialog?.nativeElement.querySelector('.focusable:last-of-type').focus();
  }

  public toggleDialog(): void {
    this.isDialogOpen = !this.isDialogOpen;

    if (this.isDialogOpen) {
      setTimeout(() => this.focusDialogTitle(), 0);
    }
  }
}
